import { Box } from "@chakra-ui/react";
import EditDsrPostInputModal from './EditDsrPostInputModal';
import DsrEditReplyModal from './DsrEditReplyModal';
import DsrManageTeamModal from '../dsr-team-mgmt/DsrManageTeamModal';
import CreateDsrPostInputModal from "./CreateDsrPostInputModal";
import DsrLoomRecordModal from "../dsr-record-content/DsrLoomRecordModal";
import DsrRevertToDraftModal from "../dsr-general-mgmt/DsrRevertToDraftModal";
import DsrRepublishModal from "../dsr-general-mgmt/DsrRepublishModal";
import DsrPublishModal from "../dsr-general-mgmt/DsrPublishModal";
import DsrConfirmRemoveMemberModal from "../dsr-general-mgmt/DsrConfirmRemoveMemberModal";
import ConfirmDeleteFaqQuestionModal from "../dsr-content-components/dsr-faq/ConfirmDeleteFaqQuestionModal";
import DsrDeleteModal from "../dsr-general-mgmt/DsrDeleteModal";
import ManageDsrLogoModal from "../dsr-draft/ManageDsrLogoModal";
import ProspectDsrPublishModal from "../dsr-prospecting/draft-prospect-dsr/ProspectDsrPublishModal";
import ProspectDsrRepublishModal from "../dsr-prospecting/draft-prospect-dsr/ProspectDsrRepublishModal";
import ProspectDsrUnpublishModal from "../dsr-prospecting/draft-prospect-dsr/ProspectDsrUnpublishModal";
import ProspectDsrDeleteModal from "../dsr-prospecting/ProspectDsrDeleteModal";
import SignupLoginModal from "../dsr-content-components/public-dsr/SignupLoginModal";
import ShareProspectDsrModal from "../dsr-prospecting/ShareProspectDsrModal";
import DsrPreviewPageActionModal from "../dsr-general-mgmt/DsrPreviewPageActionModal";
import SubscriptionNudgeModal from "../../marketing/components/SubscriptionNudgeModal";
import LoggedInUserJoinRoomModal from "../dsr-content-components/public-dsr/LoggedInUserJoinRoomModal";
import SwitchDemoToOrgAdminUserModal from "../../global/components/product-marketing/SwitchDemoToOrgAdminUserModal";
import DuplicateDsrModal from "../../dashboard/components/vault/DuplicateDsrModal";
import DsrMassManageCustomPagesModal from "../dsr-general-mgmt/DsrMassManageCustomPagesModal";
import EditSharedDocModal from "../dsr-shared-docs/EditSharedDocModal";
import CreateDsrTemplateModal from "../../dashboard/components/vault/CreateDsrTemplateModal";
import ConfirmDeleteDsrTemplateModal from "../dsr-template/ConfirmDeleteDsrTemplateModal";
import ConfirmCreateDsrFromTemplateModal from "../dsr-template/ConfirmCreateDsrFromTemplateModal";
import CreateDsrTemplateTutorialModal from "../dsr-draft/tutorial/CreateTemplatesTutorialModal";
import { removeEmptySubWidgets, removeEmptyWidgets } from "../helpers/dsr-draft-helpers";
import IdleRoomUnlockedModal from "../dsr-general-mgmt/IdleRoomUnlockedModal";
import CreateRoomWithAiModal from "../../dashboard/components/vault/CreateRoomWithAiModal";
import CreateDsrModal from "../../dashboard/components/CreateDsrModal";
import DsrCardUnpublishModal from "../dsr-general-mgmt/DsrCardUnpublishModal";
import DsrPublishCardModal from "../dsr-general-mgmt/DsrPublishCardModal";
import ProspectDsrCardUnpublishModal from "../dsr-prospecting/draft-prospect-dsr/ProspectDsrCardUnpublishModal";
import ProspectDsrPublishCardModal from '../dsr-prospecting/draft-prospect-dsr/ProspectDsrCardPublishModal';
import DsrReportModal from "./DsrReportModal";
import ConfirmDeleteJoinRequestModal from "../../dashboard/components/vault/ConfirmDeleteJoinRequestModal";
import CreateNewFaqQuestionModal from "./CreateNewFaqQuestionModal";


export default function DsrDynamicModal({
  userActionRequired,
  modalTransferPayload,
  showDsrModal,
  showDsrModalLoader,
  handleDsrModalClose, 
  handleUpdatePostContent,
  handleEditPostReply,
  handleCreateNewPost,
  // Content
  dsrId,
  pDsrId,
  dsrPages,
  // UX Management
  handleChangeUserActionRequired,
  editDsrFeedReplyOutcome,
  showPostUploadImageOption,
  // Post moderation
  handleReportPost,
  handleReportReply,
  // For refactoring
  postTagProperties,
}) {
  
  const removeEmptyWidgetsAndSubwidgets = (dsrPages) => {
    if (dsrPages) {
      const clearedWidgets = removeEmptySubWidgets(dsrPages);
      const filteredDsrPages = removeEmptyWidgets(clearedWidgets);

      return filteredDsrPages
    } else return null
  }

  const displayModalContent = () => {
    switch (userActionRequired) {
      // Creating
      case ('create-new-post'): {
        if (showDsrModal === true) {
          return (
            <CreateDsrPostInputModal
              handleCloseModal={handleDsrModalClose} 
              handleCreateNewPost={handleCreateNewPost}
              userActionRequired={userActionRequired}
              showDsrModalLoader={showDsrModalLoader}
              showPostUploadImageOption={showPostUploadImageOption}
              postTagProperties={postTagProperties}
              dsrId={dsrId}
            />
          )
        } else return null;
      }
      case ('create-question-in-faq-page'): {
        // From FAQ page
        if (showDsrModal === true) {
          return (
            <CreateNewFaqQuestionModal
              dsrId={dsrId}
              handleCloseModal={handleDsrModalClose}
              userActionRequired={userActionRequired}
            />
          )
        } else return null;
      }
      case ('create-faq-question'): {
        // From Updates page
        if (showDsrModal === true) {
          return (
            <CreateDsrPostInputModal
              handleCloseModal={handleDsrModalClose}
              handleCreateNewPost={handleCreateNewPost} // TODO:  Consider changing this to creating a new Q&A question, with automated features
              userActionRequired={userActionRequired}
            />
          )
        } else return null;
      }
      // Updating
      case ('edit-dsr-message-post'): {
        if (showDsrModal === true) {
          return (
            <EditDsrPostInputModal
              handleCloseModal={handleDsrModalClose}
              handleUpdatePostContent={handleUpdatePostContent}
              dsrId={dsrId}
              showDsrModalLoader={showDsrModalLoader}
              modalTransferPayload={modalTransferPayload}
            />
          )
        } else return null;
      }
      case ('edit-dsr-reply'): {
        if (showDsrModal === true) {
          return (
            <DsrEditReplyModal
              handleCloseModal={handleDsrModalClose}
              handleEditPostReply={handleEditPostReply}
              dsrId={dsrId}
              editDsrFeedReplyOutcome={editDsrFeedReplyOutcome}
              showDsrModalLoader={showDsrModalLoader}
              modalTransferPayload={modalTransferPayload}
            />
          )

        } else return null;
      }
      case ('view-team-members'): {
        if (showDsrModal === true) {
          return (
            <DsrManageTeamModal
              dsrId={dsrId}
              handleCloseModal={handleDsrModalClose}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
            />
          )
        } else return null;
      }
      case ('revert-dsr-to-draft'): {
        // Note: Unpublish DSR
        return (
          <DsrRevertToDraftModal
            dsrId={dsrId}
            handleCloseModal={handleDsrModalClose}
          />
        )
      }
      case ('re-publish-dsr'): {
        if (showDsrModal === true) {
          const filteredDsrPages = removeEmptyWidgetsAndSubwidgets(dsrPages)
            if (filteredDsrPages) {
              return (
                <DsrRepublishModal
                  dsrId={dsrId}
                  dsrPages={filteredDsrPages}
                  handleCloseModal={handleDsrModalClose}
                />
              )
            }
        } else return null;

        break;
      }
      case ('publish-dsr'): {
        if (showDsrModal === true) {
          const filteredDsrPages = removeEmptyWidgetsAndSubwidgets(dsrPages)
          if (filteredDsrPages) {
            return (
              <DsrPublishModal
                dsrId={dsrId}
                dsrPages={filteredDsrPages}
                handleCloseModal={handleDsrModalClose}
                handleChangeUserActionRequired={handleChangeUserActionRequired}
              />
            )
          } else return null;
        } else return null;
      }
      case ('publish-dsr-card'): {
        const {dsrStatus} = modalTransferPayload || {};

        if (dsrStatus==="draft") {
          return (
            <DsrPublishCardModal
              handleCloseModal={handleDsrModalClose}
              modalTransferPayload={modalTransferPayload}
            />
          )
        } else if (dsrStatus === "reverted-draft") {
          return (
            <DsrPublishCardModal
              handleCloseModal={handleDsrModalClose}
              modalTransferPayload={modalTransferPayload}
            />
          ) 
        } else return null
        
      }
      case ('unpublish-dsr-card'): {
        return (
          <DsrCardUnpublishModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
        )
      }
      case ('publish-prospect-dsr'): {
        const filteredDsrPages = removeEmptyWidgetsAndSubwidgets(dsrPages)
        if (filteredDsrPages) {
          return (
            <ProspectDsrPublishModal
              pDsrId={pDsrId}
              dsrPages={filteredDsrPages}
              handleCloseModal={handleDsrModalClose}
            />
          ) 
        } else return null;
      }
      case ('publish-prospect-dsr-card'): {
        if (showDsrModal === true) {
          return (
            <ProspectDsrPublishCardModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case ('unpublish-prospect-dsr-card'): {
        if (showDsrModal === true) {
          return (
            <ProspectDsrCardUnpublishModal
              handleCloseModal={handleDsrModalClose}
              modalTransferPayload={modalTransferPayload}
            />
          )
        } else return null;
      }
      case ('unpublish-prospect-dsr'): {
        if (showDsrModal === true) {
          return (
            <ProspectDsrUnpublishModal
              pDsrId={pDsrId}
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }
      case ('re-publish-prospect-dsr'): {
        if (showDsrModal === true) {
          const filteredDsrPages = removeEmptyWidgetsAndSubwidgets(dsrPages)
          return (
            <ProspectDsrRepublishModal
              pDsrId={pDsrId}
              dsrPages={filteredDsrPages}
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null
      }
      case ('delete-prospect-dsr'): {
        if (showDsrModal === true) {
          return (
            <ProspectDsrDeleteModal
            pDsrId={pDsrId}
            handleCloseModal={handleDsrModalClose}
          />
          )
        } else return null
      }
      case ('delete-dsr'): {
        if (showDsrModal) {
          return (
            <DsrDeleteModal
              dsrId={dsrId}
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }
      case ('create-new-reply'): {
        // Replies are not managed through modals
        break;
      }
      case ('create-video-post'): {
        return <DsrLoomRecordModal
          handleCloseModal={handleDsrModalClose}
          handleCreateNewPost={handleCreateNewPost}
          userActionRequired={userActionRequired}
          showDsrModalLoader={showDsrModalLoader}
        />
      }
      case ('confirm-delete-faq-question'): {
        if (showDsrModal === true) {
          return (
            <ConfirmDeleteFaqQuestionModal
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }
      case ('confirm-dsr-remove-user'): {
        if (showDsrModal === true) {
          return (
            <DsrConfirmRemoveMemberModal
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              handleCloseModal={() => handleChangeUserActionRequired('view-team-members', null)}
              modalTransferPayload={modalTransferPayload}
            />
          )
        } else return null;
      }
      case ("manage-dsr-audience-logo"): {
        if (showDsrModal === true) {
          return (
            <ManageDsrLogoModal
              dsrId={dsrId}
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }

      // Product Marketing
      case ('subscription-nudge'): {
        if (showDsrModal === true) {
          return (
            <SubscriptionNudgeModal
              titleText={modalTransferPayload?.titleText}
              copyText={modalTransferPayload?.copyText}
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }
      case ('show-signup-login-prompt'): {
        if (showDsrModal === true) {
          return (
            <SignupLoginModal
              dsrId={dsrId}
              handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }
      case ('show-preview-page-action-modal'): {
        if (showDsrModal === true) {
          return (
            <DsrPreviewPageActionModal handleCloseModal={handleDsrModalClose} />
          )
        } else return null;
      }
      case('share-prospect-dsr'): {
        if (showDsrModal === true) {
          return (
            <ShareProspectDsrModal
            pDsrId={pDsrId}
            handleCloseModal={handleDsrModalClose}
          />
          )
        } else return null;
      }
      case('show-add-logged-in-user-prompt'): {
        if (showDsrModal === true) {
          return (
            <LoggedInUserJoinRoomModal
            dsrId={dsrId}
            handleCloseModal={handleDsrModalClose}
          />
          )
        } else return null;
      }
      case('switch-demo-user-to-org-admin-view'): {
        if (showDsrModal === true) {
          return (
            <SwitchDemoToOrgAdminUserModal
            dsrId={dsrId}
            handleCloseModal={handleDsrModalClose}
          />
          )
        } else return null;
      }
      case('duplicate-dsr'): {
        if (showDsrModal === true) {
          return (
            <DuplicateDsrModal
            dsrId={dsrId}
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case('make-dsr-template'): {
        if (showDsrModal === true) {
          return (
            <CreateDsrTemplateModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case('mass-manage-dsr-custom-pages'): {
        if (showDsrModal === true) {
          return (
            <DsrMassManageCustomPagesModal
            dsrId={dsrId}
            pDsrId={pDsrId}
            handleCloseModal={handleDsrModalClose}
          />
          )
        } else return null;
      }
      case('edit-shared-doc'): {
        if (showDsrModal === true) {
          return (
            <EditSharedDocModal
            dsrId={dsrId}
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case('confirm-delete-template'): {
        if (showDsrModal === true) {
          return (
            <ConfirmDeleteDsrTemplateModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case('show-create-dsr-with-template-modal'): {
        if (showDsrModal === true) {
          return (
            <ConfirmCreateDsrFromTemplateModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case('show-create-template-tutorial-modal'): {
        if (showDsrModal === true) {
          return (
            <CreateDsrTemplateTutorialModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      case('idle-room-unlocked'): {
        if (showDsrModal === true) {
          return (
            <IdleRoomUnlockedModal />
          )
        } else return null;
      }
      case('create-room-with-ai-form'): {
        if (showDsrModal === true) {
          return (
            <CreateRoomWithAiModal 
            handleCloseModal={handleDsrModalClose}
            />
          )
        } else return null;
      }
      case('create-new-room-form'): {
        if (showDsrModal === true) {
          return (
            <CreateDsrModal
            handleCloseCreateDsrModal={handleDsrModalClose}
            formType={"dsr"}
          />
          )
        } else return null;
      }
      case('create-new-prospect-room-form'): {
        if (showDsrModal === true) {
          return (
            <CreateDsrModal
            handleCloseCreateDsrModal={handleDsrModalClose}
            formType={"prospect-dsr"}
          />
          )
        } else return null;
      }
      case('report-updates-post'): {
        if (showDsrModal === true) {
          return (
            <DsrReportModal
            handleCloseModal={handleDsrModalClose}
            handleReportPost={handleReportPost}
            formType={"report-post"}
            modalTransferPayload={modalTransferPayload}
            showDsrModalLoader={showDsrModalLoader}
          />
          )
        } else return null;
      }
      case('report-updates-reply'): {
        if (showDsrModal === true) {
          return (
            <DsrReportModal
            handleCloseModal={handleDsrModalClose}
            handleReportReply={handleReportReply}
            formType={"report-reply"}
            modalTransferPayload={modalTransferPayload}
            showDsrModalLoader={showDsrModalLoader}
          />
          )
        } else return null;
      }
      case('delete-join-room-request'): {
        if (showDsrModal === true) {
          return (
            <ConfirmDeleteJoinRequestModal
            handleCloseModal={handleDsrModalClose}
            modalTransferPayload={modalTransferPayload}
          />
          )
        } else return null;
      }
      default: {
        console.log('This user action is not valid for dynamic modal:', userActionRequired)
        return null;
      }
    }
  }

  if (userActionRequired) {
    return <Box>{displayModalContent()}</Box>
  } else return null;
 
}
